import { useCallback, useContext, useEffect } from 'react';
import FrameworkContext from '../framework/FrameworkContext';


function useFrameworkLoading(defaultValue) {
  const {state, dispatch} = useContext(FrameworkContext);
  const { loading } = state;

  useEffect(() => {
    console.log('defaultValue', defaultValue);
    dispatch({
      payload:{
        loading: defaultValue
      }
    })
  }, [dispatch, defaultValue]);
  
  const setLoading = useCallback((val) => {
    console.log('val', val);
    dispatch({
      payload: {
        loading: val
      }
    })
  }, [dispatch]);

  return [loading, setLoading]
}

export default useFrameworkLoading
